import * as React from "react";
import { Descriptions, Row, Col } from "antd";
import { IReportingPeriod } from "../../../model/reporting/ReportingPeriod";
import { DateService } from "../../../service/DateService";

const formatReportingPeriodDate = (periodFrom?: Date, periodTo?: Date) => {
  const formatPeriodFrom = periodFrom
    ? DateService().formatDate(periodFrom)
    : "";
  const formatPeriodTo = periodTo ? DateService().formatDate(periodTo) : "";

  return `${formatPeriodFrom} - ${formatPeriodTo}`;
};

const ReportingPeriodDetails = ({
  reportingPeriod,
  translate,
  className
}: {
  reportingPeriod: IReportingPeriod;
  translate: any;
  className?: string;
}) => {
  return (
    <div className={className}>
      <Row>
        <Col xs={24} sm={12}>
          <Descriptions
            column={1}
            bordered
            size={"small"}
            layout={"horizontal"}
          >
            {reportingPeriod.periodFrom && reportingPeriod.periodTo ? (
              <Descriptions.Item
                label={translate("portal.reporting_period.period")}
              >
                {formatReportingPeriodDate(
                  reportingPeriod.periodFrom,
                  reportingPeriod.periodTo
                ) || "-"}
              </Descriptions.Item>
            ) : undefined}
            <Descriptions.Item
              label={translate("portal.reporting_period.status")}
            >
              {reportingPeriod.status || "-"}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate("portal.reporting_period.reporting_type_name")}
            >
              {reportingPeriod.reportingTypeName || "-"}
            </Descriptions.Item>
            <Descriptions.Item
              label={translate(
                "portal.reporting_period.reporting_type_description"
              )}
            >
              {reportingPeriod.reportingTypeDescription || "-"}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </div>
  );
};

export default ReportingPeriodDetails;
